import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseurl } from "../utility/helper";
import $ from "jquery";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-dt";
import "datatables.net-buttons-dt";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";

function MindMagazine() {

  const [showForm, setShowForm] = useState(false);
  let tableInstance = null;
  const [heading, setHeading] = useState("");
  const [shortDesc, setShortDesc] = useState("");
  const [longDesc, setLongDesc] = useState("");
  const [attachment, setAttachment] = useState(null);
  const [editId, setEditId] = useState(null);
  const [magazines, setMagazines] = useState([]);
  const [viewMode, setViewMode] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [currentPDF, setCurrentPDF] = useState(null);
  const [removePDF, setRemovePDF] = useState(false);

  useEffect(() => {
    fetchMagazines();
  }, []);
  

  const fetchMagazines = async () => {

    const res = await axios.get(`${baseurl}/admin/magazines`);

    setMagazines(res.data);

    setTimeout(() => {

      if ($.fn.DataTable.isDataTable("#magazineTable")) {
        $("#magazineTable").DataTable().destroy();
      }

      tableInstance = $("#magazineTable").DataTable({
        destroy: true,
        dom: "Bfrtip",
        buttons: ["copy", "csv", "excel", "print"]
      });

    }, 100);

  };

  const handleFileChange = (e) => {

    const file = e.target.files[0];

    if (file && file.type !== "application/pdf") {
      alert("Only PDF allowed");
      return;
    }

    setAttachment(file);

  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  const form = new FormData();
  form.append("heading", heading);
  form.append("short_desc", shortDesc);
  form.append("long_desc", longDesc);
  if (attachment) {
    form.append("attachment", attachment);
  }

  form.append("remove_pdf", removePDF ? "true" : "false");

  try {
    const token = sessionStorage.getItem("token");

    try {
      if (editId) {
        await axios.put(
          `${baseurl}/admin/update-magazine/${editId}`,
          form,
          { headers: { Authorization: token } }
        );
        setEditId(null);
      } else {
        await axios.post(
          `${baseurl}/admin/add-magazine`,
          form,
          { headers: { Authorization: token } }
        );
      }

      alert("Saved successfully");
    } catch (error) {
      console.error(error);
      alert("Something went wrong");
    }

    if ($.fn.DataTable.isDataTable("#magazineTable")) {
      $("#magazineTable").DataTable().destroy();
    }

    setHeading("");
    setShortDesc("");
    setLongDesc("");
    setAttachment(null);
    setShowForm(false);

    fetchMagazines();
  } catch (err) {
    console.error(err);
    Swal.fire("Error", "Failed to save magazine", "error");
  }
};

  const handlePDF = async (id) => {
    try {
      const res = await axios.get(`${baseurl}/admin/magazines/download?id=${id}`);
      const file = res.data.files[0];

      if (file && file.url) {
        const viewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(file.url)}&embedded=true`;
        window.open(viewerUrl, "_blank");
      }

    } catch (err) {
      console.error(err);
      alert("Failed to open PDF");
    }
  };

  const handleViewPDF = async (id) => {
    try {
      const res = await axios.get(`${baseurl}/admin/magazines/download?id=${id}`);
      const files = res.data.files;

      files.forEach(file => {
        const link = document.createElement("a");
        link.href = file.url;     // presigned URL
        link.download = file.filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    } catch (err) {
      console.error(err);
      alert("Failed to download PDF");
    }
  };

  // Edit magazine
  const handleEdit = (item) => {
    if ($.fn.DataTable.isDataTable("#magazineTable")) {
      $("#magazineTable").DataTable().destroy();
    }

    setHeading(item.heading);
    setShortDesc(item.short_desc);
    setLongDesc(item.long_desc);
    setCurrentPDF(item.attachment_url);

    setEditId(item.id);
    setShowForm(true);

    setViewMode(false);
    setEditMode(true);
  };

  // Delete magazine
  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This will delete the magazine and its PDF from server.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });

    if (confirm.isConfirmed) {
      const token = sessionStorage.getItem("token");

      try {
        await axios.delete(
          `${baseurl}/admin/delete-magazine/${id}`,
          {
            headers: {
              Authorization: token
            }
          }
        );

        Swal.fire("Deleted!", "Magazine deleted successfully.", "success");

        if ($.fn.DataTable.isDataTable("#magazineTable")) {
          $("#magazineTable").DataTable().destroy();
        }

        fetchMagazines();

      } catch (err) {
        console.error(err);
        Swal.fire("Error", "Failed to delete magazine.", "error");
      }
    }
  };

  const handleView = (item) => {

    if ($.fn.DataTable.isDataTable("#magazineTable")) {
      $("#magazineTable").DataTable().destroy();
    }

    setHeading(item.heading);
    setShortDesc(item.short_desc);
    setLongDesc(item.long_desc);
    setCurrentPDF(item.attachment_url);

    setEditId(item.id);

    setShowForm(true);
    setViewMode(true);
    setEditMode(false);
  };

  return (
    <div className="container mt-4">
      
      {editMode && showForm &&(
      <button type="button" className="btn btn-danger btn-sm" onClick={() => handleDelete(editId)} style={{ float : 'right'}}>
        Delete
      </button>
      )}
      <div className="profile-section">
      <h3>Manage MInd Magazine</h3>

      {/* ADD BUTTON */}

      {!showForm && (
        <button
          className="btn btn-primary mb-3" 
          style={{float:'right'}}
          onClick={() => {

            if ($.fn.DataTable.isDataTable("#magazineTable")) {
              $("#magazineTable").DataTable().destroy();
            }

            setShowForm(true);
              // reset modes
            setViewMode(false);
            setEditMode(true);

            setHeading("");
            setShortDesc("");
            setLongDesc("");
            setAttachment(null);

          }}
        >
          Add MInd Magazine
        </button>
      )}

      {viewMode && !editMode && showForm &&(
        <button
          className="btn btn-warning"
          style={{ float: "right" }}
          onClick={() => setEditMode(true)}
        >
          Edit
        </button>
      )}

      {/* FORM */}

      {showForm && (

        <div className="card">
          <div className="card-body">

            <h5>Add MInd Magazine</h5>

            <form onSubmit={handleSubmit}>

              <div className="row">

                <div className="col-md-6 mb-3">
                  <label>Heading</label>
                  <input
                    type="text"
                    className="form-control"
                    value={heading}
                    disabled={!editMode}
                    onChange={(e) => setHeading(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label>Attachment (PDF)</label>
                  <input
                    type="file"
                    className="form-control"
                    accept="application/pdf"
                    disabled={!editMode}
                    onChange={handleFileChange}
                    
                  />

                  {currentPDF && !removePDF && (
                    <div className="mb-2">
                      <button
                        type="button"
                        className="btn btn-info btn-sm"
                        onClick={() => handlePDF(editId)}
                      >
                        <i className="fas fa-file-pdf" style={{fontSize:'large'}}></i>
                      </button>

                      {editMode && (
                        <button
                          type="button"
                          className="btn btn-danger btn-sm ms-2"
                          onClick={() => {
                            setRemovePDF(true);
                            setCurrentPDF(null);
                          }}
                        >
                         <i className="fas fa-solid fa-trash" style={{fontSize:'large'}}></i>
                        </button>
                      )}
                    </div>
                  )}
                </div>

                

                <div className="col-md-12 mb-3">
                  <label>Short Description</label>
                  <textarea
                    className="form-control"
                    rows="2"
                    value={shortDesc}
                    disabled={!editMode}
                    onChange={(e) => setShortDesc(e.target.value)}
                  />
                </div>

                <div className="col-md-12 mb-3">
                  <label>Long Description</label>
                  <textarea
                    className="form-control"
                    rows="4"
                    value={longDesc}
                    disabled={!editMode}
                    onChange={(e) => setLongDesc(e.target.value)}
                  />
                </div>

                <div className="col-md-12">

                 {editMode && (
                    <button className="btn btn-success">
                      Update
                    </button>
                  )}

                  &nbsp;

                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {

                      setShowForm(false);

                      // reset states
                      setViewMode(false);
                      setEditMode(false);
                      setEditId(null);
                      setCurrentPDF(null);
                      setRemovePDF(false);

                      setHeading("");
                      setShortDesc("");
                      setLongDesc("");
                      setAttachment(null);

                      fetchMagazines(); // reload table + datatable
                    }}
                  >
                    Cancel
                  </button>

                </div>

              </div>

            </form>

          </div>
        </div>

      )}

      {/* TABLE */}

      {!showForm && (
        <div className="table-responsive">
          <table
            id="magazineTable"
            className="table table-striped table-bordered"
          >

            <thead>

              <tr>
                <th>Sr.No</th>
                <th>Heading</th>
                <th>Short Description</th>
                <th>Long Description</th>
                <th>Attachment</th>
              </tr>

            </thead>

            <tbody>

              {magazines.map((item, index) => (

                <tr key={item.id}>

                  <td><span
                      style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
                      onClick={() => handleView(item)}
                    > {index + 1}</span></td>

                  <td> {item.heading} </td>

                  <td>{item.short_desc}</td>

                  <td style={{textWrap:'wrap'}}>{item.long_desc}</td>

                  <td>
                  <td>
                      {(() => {
                        try {
                          const files = JSON.parse(item.attachment_url || "[]");
                          return files.length > 0 ? (
                            <button
                              type="button"
                              className="btn btn-info btn-sm"
                              onClick={() => handleViewPDF(item.id)}
                            >
                              <i className="fas fa-file-pdf" style={{ fontSize: "large" }}></i>
                            </button>
                          ) : null;
                        } catch {
                          return null;
                        }
                      })()}
                      &nbsp;
                      <button
                        type="button"
                        className="btn btn-warning btn-sm"
                        onClick={() => handleEdit(item)}
                      >
                        <i className="fas fa-solid fa-pen-to-square" style={{fontSize:'large'}}></i>
                      </button>
                      &nbsp;
                      {/* <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDelete(item.id)}
                      >
                        <i className="fas fa-solid fa-trash" style={{fontSize:'large'}}></i>
                      </button> */}
                    </td>
                </td>

                </tr>

              ))}

            </tbody>

          </table>
        </div>
      )}
</div>
    </div>
  );
}

export default MindMagazine;